import React from 'react';
import { Box, Container, Divider, Link, Paper, Typography } from '@mui/material';
import Seo from '../../Components/Seo';

const Terms = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 6 }}>
            <Seo
                title="Terms of Use"
                description="Terms of Use for Radiology Illustration, an educational radiology and medical illustration website by Dr. Shubham Arora."
                canonicalPath="/terms"
            />
            <Paper elevation={3} sx={{ p: { xs: 3, md: 5 } }}>
                <Typography variant="h1" align="center" sx={{ fontSize: { xs: '2rem', md: '2.8rem' }, fontWeight: 700, mb: 1 }}>
                    Terms of Use
                </Typography>
                <Typography variant="subtitle1" align="center" color="text.secondary" gutterBottom>
                    Last updated: July 25, 2026
                </Typography>

                <Box sx={{ mt: 4 }}>
                    <Typography variant="h2" sx={{ fontSize: '1.35rem', fontWeight: 700 }} gutterBottom>
                        Educational Use
                    </Typography>
                    <Typography paragraph>
                        Radiology Illustration provides educational content for students, educators, radiology trainees, and healthcare professionals. The material is intended for learning, teaching, and general informational use only.
                    </Typography>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Box>
                    <Typography variant="h2" sx={{ fontSize: '1.35rem', fontWeight: 700 }} gutterBottom>
                        Not Medical Advice
                    </Typography>
                    <Typography paragraph>
                        The website does not provide individual medical advice, diagnosis, or treatment. Clinical decisions should always be made with qualified healthcare professionals and appropriate institutional guidance.
                    </Typography>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Box>
                    <Typography variant="h2" sx={{ fontSize: '1.35rem', fontWeight: 700 }} gutterBottom>
                        Intellectual Property
                    </Typography>
                    <Typography paragraph>
                        Unless otherwise stated, illustrations, text, graphics, and other educational materials on this website are owned by Radiology Illustration or their respective creators. You may link to public pages for educational reference, but you may not copy, republish, sell, or redistribute site content without permission.
                    </Typography>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Box>
                    <Typography variant="h2" sx={{ fontSize: '1.35rem', fontWeight: 700 }} gutterBottom>
                        External Links
                    </Typography>
                    <Typography paragraph>
                        The website may link to social platforms, publications, video pages, or other third-party resources. Those websites are controlled by their own owners and are governed by their own terms and privacy practices.
                    </Typography>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Box>
                    <Typography variant="h2" sx={{ fontSize: '1.35rem', fontWeight: 700 }} gutterBottom>
                        Contact
                    </Typography>
                    <Typography paragraph>
                        For permissions, corrections, or questions about these terms, please use the <Link href="/contact">contact page</Link>.
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default Terms;
